import Vue from 'vue';
import ExtensionPoints from '../model/ExtensionPoints';

export default (extensionsPoints: ExtensionPoints) => {
  Object.entries(extensionsPoints).forEach(([name, component]) => {
    Vue.component(name, component);
  });
};
